/* eslint-disable prefer-destructuring */
export default class BrowserDetect {
  name: string | null;

  version: string | null;

  os: string | null;

  osVersion: string | null;

  mobile: boolean;

  desktop: boolean;

  constructor() {
    if (navigator.userAgent.search(/mobile/gi) >= 0) {
      this.mobile = true;
      this.desktop = false;
    } else {
      this.mobile = false;
      this.desktop = true;
    }
    const browserInfo = this.detectBrowserInformation();
    this.name = browserInfo[0];
    this.version = browserInfo[1];

    const systemInfo = this.detectSystemInformation();
    this.os = systemInfo[0];
    this.osVersion = systemInfo[1];
  }

  searchBrowser() {
    const regex = /((edg[e|a|ios]*)|opr|opt|edge|firefox|crios)\/\d*.\d*/gi;
    const browser = navigator.userAgent.match(regex);

    if (browser !== null) return browser;
    if (navigator.vendor.search(/(google)/gi) >= 0)
      return navigator.userAgent.match(/(chrome)\/\d*.\d*/gi);
    if (navigator.vendor.search(/(apple)/gi) >= 0)
      return navigator.userAgent.match(/(safari)\/\d*.\d*/gi);

    return null;
  }

  replaceBrowserName(browserName: string) {
    switch (browserName.toLowerCase()) {
      case 'edg':
      case 'edga':
      case 'edgios':
        return 'Egde (Chromium)';

      case 'crios':
        return 'Chrome';

      case 'opr':
        return 'Opera';

      case 'opt':
        return 'Opera Touch';

      default:
        return browserName.trim();
    }
  }

  detectBrowserInformation() {
    const browser = this.searchBrowser();
    if (browser === null) return ['Não identificado', null];

    const parsedData = browser[0].split('/');
    const browserVersion = parsedData[1].match(/\d+/g);

    return [
      parsedData[0].replace(/((edg[e|a|ios]*)|opr|opt|crios)/gi, this.replaceBrowserName),
      browserVersion === null ? null : browserVersion[0].trim(),
    ];
  }

  windowsVersion(version: string | null) {
    if (version === '10.0') return '10';
    if (version === '6.3') return '8.1';
    if (version === '6.2') return '8';
    if (version === '6.1') return '7';
    if (version === '6.0') return 'Vista';
    if (version === '5.1') return 'XP';

    return null;
  }

  detectSystemInformation() {
    const system = navigator.userAgent.match(/\(([^)]+)\)/);
    if (system === null) return ['Não identificado', null];

    const systemData = system[1].split(';').join(' ').trim();

    if (this.desktop) {
      if (navigator.userAgent.search(/windows nt \d+.\d+/gi) >= 0) {
        const windows = systemData.match(/windows nt \d+.\d+/gi);
        if (windows === null) return ['Windows', null];

        return [
          windows[0].replace(/\d|\./g, '').trim(),
          this.windowsVersion(windows[0].replace(/[^\d+.\d+]/g, '')),
        ];
      }

      if (navigator.userAgent.search(/linux/gi) >= 0) {
        const distribution = systemData.match(/(debian|ubuntu|fedora|mint|elementary os)/gi);
        const version = systemData.match(/\/\d+.\d+/g);

        return [
          distribution !== null ? distribution[0] : 'Linux',
          version !== null ? version[0].replace(/\//g, '') : null,
        ];
      }

      if (navigator.userAgent.search(/macintosh/gi) >= 0) {
        const mac = systemData.match(/(mac os x \d+_\d*)/gi);
        if (mac === null) return ['Macintosh', null];

        return [
          mac[0].replace(/[\d_]/gi, '').trim(),
          mac[0]
            .replace(/[^\d_]/gi, '')
            .replace(/_/g, '.')
            .trim(),
        ];
      }
    }

    if (this.mobile) {
      if (navigator.userAgent.search(/android/gi) >= 0) {
        const android = systemData.match(/android \d*.\d*/gi);
        if (android === null) return ['Android', null];

        const parsedData = android[0].split(' ');
        return [parsedData[0].trim(), parsedData[1].trim()];
      }

      if (navigator.userAgent.search(/(ipad|iphone)/gi) >= 0) {
        const version = systemData.match(/\d+_\d+/gi);
        return ['iOS', version === null ? null : version[0].replace(/_/g, '.').trim()];
      }
    }

    return ['Não identificado', null];
  }
}
